import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Login from './views/Login';
import ManageUsers from './views/ManageUsers';
import UserForm from './views/UserForm';
import DeviceManagement from './views/DeviceManagement';
import DeviceForm from './views/DeviceForm';
import DataEntry from './views/DataEntry';
import ReportPage from './views/ReportPage';
import StorageStateReport from './views/StorageStateReport';
import PrivateRoute from './components/PrivateRoute';
import Sidebar from './components/Sidebar';
import Dashboard from './views/Dashboard';
import ProcessData from './views/ProcessData';
import AllDataPoints from './views/AllDataPoints';
import KsefTokenManagement from './views/KsefTokenManagement';
import Invoices from './views/Invoices';
import BillingRuns from './views/BillingRuns';
import Balancing from './views/Balancing';
import { hasValidToken } from './services/api';

const AppLayout = () => {
    const location = useLocation();
    const user = JSON.parse(localStorage.getItem('user'));
    const isLoggedIn = user && hasValidToken();
    const isLoginPage = location.pathname === '/login';

    return (
        <div className="min-h-screen">
            {isLoggedIn && !isLoginPage && <Sidebar />}

            <main className={`min-h-screen bg-cover bg-center ${isLoggedIn && !isLoginPage ? 'md:ml-64 pt-16 md:pt-0' : ''}`} style={{ backgroundImage: `url('/images/bg.jpg')` }}>
                <div className="p-4">
                    <Routes>
                    <Route path="/login" element={<Login />} />


                    <Route
                        path="/"
                        element={
                            !user ? (
                                <Navigate to="/login" />
                            ) : (
                                <PrivateRoute element={Dashboard} role={['user', 'admin']} />
                            )
                        }
                    />


                    <Route
                        path="/admin"
                        element={<PrivateRoute element={ManageUsers} role="admin" />}
                    />
                    <Route
                        path="/admin/users/create"
                        element={<PrivateRoute element={UserForm} role="admin" />}
                    />
                    <Route
                        path="/admin/users/edit/:username"
                        element={<PrivateRoute element={UserForm} role="admin" />}
                    />
                    <Route
                        path="/admin/devices"
                        element={<PrivateRoute element={DeviceManagement} role="admin" />}
                    />
                    <Route
                        path="/admin/devices/create"
                        element={<PrivateRoute element={DeviceForm} role="admin" />}
                    />
                    <Route
                        path="/admin/devices/edit/:deviceId"
                        element={<PrivateRoute element={DeviceForm} role="admin" />}
                    />


                    <Route
                        path="/data-entry"
                        element={<PrivateRoute element={DataEntry} role="admin" />}
                    />


                    <Route
                        path="/reports"
                        element={<PrivateRoute element={ReportPage} role={['user', 'admin']} />}
                    />

                    <Route
                        path="/storage-state"
                        element={<PrivateRoute element={StorageStateReport} role={['user', 'admin']} />}
                    />

                    <Route
                        path="/ksef-token"
                        element={<PrivateRoute element={KsefTokenManagement} role={['user', 'admin']} feature="invoicing" />}
                    />

                    <Route
                        path="/invoices"
                        element={<PrivateRoute element={Invoices} role={['user', 'admin']} feature="invoicing" />}
                    />

                    <Route
                        path="/billing-runs"
                        element={<PrivateRoute element={BillingRuns} role="admin" feature="invoicing" />}
                    />

                    <Route
                        path="/balancing"
                        element={<PrivateRoute element={Balancing} role="admin" feature="invoicing" />}
                    />


                    <Route
                        path="/all-data-points"
                        element={<PrivateRoute element={AllDataPoints} role={['admin']} />}
                    />


                    <Route
                        path="/process-data"
                        element={<PrivateRoute element={ProcessData} role={['admin']} />}
                    />


                    <Route path="*" element={<Navigate to="/" />} />
                    </Routes>
                </div>
            </main>
        </div>
    );
};

const App = () => {
    return (
        <Router>
            <AppLayout />
        </Router>
    );
};

export default App;
